import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

let configureStore;
const isProduction = false;

if (isProduction) {
  // eslint-disable-next-line global-require
  configureStore = require('./config.prod');
} else {
  // eslint-disable-next-line global-require
  configureStore = require('./config.dev');
}

const store = configureStore.default();
const history = syncHistoryWithStore(browserHistory, store);

export { store, history };



// WEBPACK FOOTER //
// ./src/store/index.js